import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import Button from '../../../components/button';
import CustomModal from '../../../components/CustomModal';
import Input from '../../../components/input';
import Select from '../../../components/Select';
import { updateVehicleTypeAsync, fetchVehicleTypes, getVehicleTypesOverview } from '../../../store/Slices/VehicleTypeSlice';
import { vehicleTypeValidationSchema } from '../../../utils/Schema';
import { vehicleTypeStatusOptions, vehicleClassOptions } from '../../../utils/Dropdowns';
import { errorNotify, successNotify } from '../../../utils/toast';

const UpdateVehicleTypeModal = ({ show, onHide, vehicleType, currentPage, limit }) => {
    const dispatch = useDispatch();
    const { updateVehicleTypeLoading } = useSelector((state) => state.vehicleTypes);

    const initialValues = {
        title: vehicleType?.title || '',
        status: vehicleType?.status || 'active',
        vehicle_class: vehicleType?.vehicle_class || 'pool'
    };

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const payload = {
                id: vehicleType.id,
                ...values
            };
            await dispatch(updateVehicleTypeAsync(payload)).unwrap();
            successNotify('Vehicle type updated successfully');
            onHide();
            
            // Refresh table and overview
            dispatch(fetchVehicleTypes({
                page: currentPage,
                limit: limit,
                body: {}
            }));
            dispatch(getVehicleTypesOverview());
        } catch (error) {
            errorNotify(error);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <CustomModal heading="Update Vehicle Type" size="lg" show={show} handleClose={onHide}>
            <Formik
                initialValues={initialValues}
                validationSchema={vehicleTypeValidationSchema}
                onSubmit={handleSubmit}
                enableReinitialize={true}
            >
                {({ values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting }) => (
                    <Form>
                        <div className="add_user_modal">
                            <h5>Vehicle Type Information</h5>
                            <div>
                                <Input
                                    label="Title"
                                    placeholder="Enter vehicle type title"
                                    type="text"
                                    name="title"
                                    value={values.title}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.title}
                                    touched={touched.title}
                                />
                            </div>

                            <div>
                                <Select
                                    label="Vehicle Class"
                                    placeholder="Select vehicle class"
                                    options={vehicleClassOptions}
                                    name="vehicle_class"
                                    value={vehicleClassOptions.find(opt => opt.value === values.vehicle_class)}
                                    onChange={(option) => setFieldValue('vehicle_class', option?.value || '')}
                                    onBlur={handleBlur}
                                    error={errors.vehicle_class}
                                    touched={touched.vehicle_class}
                                />
                                <Select
                                    label="Status"
                                    placeholder="Select status"
                                    options={vehicleTypeStatusOptions}
                                    name="status"
                                    value={vehicleTypeStatusOptions.find(opt => opt.value === values.status)}
                                    onChange={(option) => setFieldValue('status', option?.value || '')}
                                    onBlur={handleBlur}
                                    error={errors.status}
                                    touched={touched.status}
                                />
                            </div>

                            <div className="d-flex align-items-center gap-2" style={{ marginTop: "40px" }}>
                                <Button
                                    submitBtn={() => {}}
                                    loading={updateVehicleTypeLoading || isSubmitting}
                                    disabled={updateVehicleTypeLoading || isSubmitting}
                                    submitText="Update"
                                    type="submit"
                                    shouldRow={false}
                                    isShowSubmitBtn={true}
                                    isShowCancel={false}
                                />
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </CustomModal>
    );
};

export default UpdateVehicleTypeModal;
